import React, { Component } from 'react';
import Auth0ContactForm from 'auth0-contact-form';

class VideoFooter extends Component {
  componentDidMount() {
    const { metricsLib } = window;

    this.contactForm = new Auth0ContactForm({
      source: 'docs',
      modalTitle: 'Contact for Instructor-led Training',
      scheduling: false,
      includePhoneField: false,
      postUrl: 'https://wtg-docs-forms.sandbox.auth0-extend.com/form-handler',
      includeRoleField: true,
      dictionary: {
        send: 'Send'
      },
      onModalOpen() {
        metricsLib.track('open:talk-to-training');
      },
      onFormSuccess(metricsData) {
        metricsLib.track('register:lead:talk-to-training-modal', metricsData);
        metricsLib.track('sent:talk-to-training', metricsData);
      },
      onFormFail(metricsData) {
        metricsLib.track('fail:register:lead:talk-to-training-modal', metricsData);
        metricsLib.track('fail-sent:talk-to-training', metricsData);
      }
    });
  }

  render() {
    return (
      <div className="try-banner">
        <span>Interested in instructor-led version of this training?</span>
        <a onClick={() => this.contactForm.show()} className="btn btn-success btn-lg">Contact Training</a>
      </div>
    );
  }
}

export default VideoFooter;

